import {ProgressBar} from '../ProgressBar';

export const EmployeeRow = ({item, index, groupLetter, sortBy}) => {
  const renderLetterColumn = () => {
    if (sortBy === 'alphabetical') {
      if (index === 0) {
        return (
          <div className='baseline-letter-column baseline-letter-active'>
            {groupLetter}
          </div>
        );
      }
      return <div className='baseline-letter-column'></div>;
    }
    return <div className='baseline-letter-column'></div>;
  };

  return (
    <div className='baseline-employee-row'>
      {renderLetterColumn()}
      <div className='baseline-employee-content'>
        <div className='baseline-employee-name'>
          <div className='baseline-employee-name-text'>
            {item.first_name} {item.last_name}
          </div>
        </div>

        <div className='baseline-progress-section'>
          <div className='baseline-progress-label'>Pre-Shift</div>
          <ProgressBar
            completed={item.pre_shift_completed}
            required={item.pre_shift_required}
            type='pre'
          />
        </div>

        <div className='baseline-progress-section'>
          <div className='baseline-progress-label'>Post-Shift</div>
          <ProgressBar
            completed={item.post_shift_completed}
            required={item.post_shift_required}
            type='post'
          />
        </div>

        <div className='baseline-total-section'>
          <div className='baseline-total-text'>
            {item.total_completed > item.total_required
              ? item.total_required
              : item.total_completed}
            /{item.total_required}
          </div>
        </div>
      </div>
    </div>
  );
};